export * from 'skypager-util/lib/entity'


// WEBPACK FOOTER //
// ./src/entity.js